// extracted by mini-css-extract-plugin
module.exports = {"text":"KcSafety_text__ZQCI8","icon":"KcSafety_icon__AHb0g"};